import y from "./contact-channels78.js";
function a(t) {
  "@babel/helpers - typeof";
  return a = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, a(t);
}
function c(t, e) {
  y(t);
  var n, r;
  a(e) === "object" ? (n = e.min || 0, r = e.max) : (n = arguments[1] || 0, r = arguments[2]);
  var f = t.match(/(\uFE0F|\uFE0E)/g) || [], i = t.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g) || [], u = t.length - f.length - i.length, o = u >= n && (typeof r > "u" || u <= r);
  return o && Array.isArray(e == null ? void 0 : e.discreteLengths) ? e.discreteLengths.some(function(m) {
    return m === u;
  }) : o;
}
export {
  c as default
};
//# sourceMappingURL=contact-channels64.js.map
